import LeftMoveEffect from './LeftMoveEffect';
import RightMoveEffect from './RightMoveEffect';
import * as Styled from './index.styles';

const MobilePageChangeEffectLayer = () => {
  return (
    <Styled.FlexPageMoveButtonWrapper
      alignItems="center"
      justifyContent="space-between"
    >
      <LeftMoveEffect />
      <RightMoveEffect />
    </Styled.FlexPageMoveButtonWrapper>
  );
};

export default MobilePageChangeEffectLayer;
